module.exports = "/_next/static/resources/jost.var-2e8383a2553004427ee11018fed219bc.woff2";